import React from 'react';
import Dropzone from 'react-dropzone';


const renderFiles = ({ label, input, funcao, maxSize,multiple, accept,textField, meta: {touched, error} }) =>(
    <div className="form-group">
      {label ? <label className="control-label">{label}</label> : ""} 
         <Dropzone
                 {...input} 
                className = "uploadFile"
                multiple  = {multiple?true:false}
                accept    = {accept}
                maxSize   = {maxSize} 
                onDrop    = {funcao}>
                <div>{textField}</div>
        </Dropzone>
        {touched && error && <span className="text-danger">{error}</span>}
    </div>  
);

export default renderFiles;


// WEBPACK FOOTER //
// ./src/container/renderFiles.js